export default __webpack_public_path__ + "static/media/masai_refresh1.f5ac4794.png";